import React from 'react';

const DemoDetailsView: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Demo Details</h1>
      <p className="text-gray-600">Demo details view component - to be implemented</p>
    </div>
  );
};

export default DemoDetailsView;
